import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FileFallbackService {
  private primary = environment.filesUrl;
  private backup = environment.filesUrl2;

  constructor() {
    if (!this.primary || !this.backup || this.primary === this.backup) {
      return;
    }
    document.addEventListener(
      'error',
      (event: Event) => {
        this.handleError(event);
      },
      true
    );
  }

  private handleError(event: Event): void {
    const target = event.target as HTMLElement;

    if (target instanceof HTMLImageElement) {
      if (target.hasAttribute('data-file-fallback')) {
        return;
      }
      this.applyFallback(target, 'src');
      return;
    }

    if (target instanceof HTMLMediaElement) {
      if (target.hasAttribute('data-file-fallback')) {
        return;
      }
      const current = target.currentSrc || target.src || '';
      const swapped = this.swap(current);
      if (swapped && swapped !== current) {
        target.setAttribute('data-file-fallback', 'true');
        if (target instanceof HTMLVideoElement && target.poster) {
          const swappedPoster = this.swap(target.poster);
          if (swappedPoster) {
            target.setAttribute('poster', swappedPoster);
          }
        }
        target.src = swapped;
        target.load();
      }
      return;
    }

    if (target instanceof HTMLSourceElement) {
      const parent = target.parentNode;
      if (
        parent instanceof HTMLMediaElement &&
        !parent.hasAttribute('data-file-fallback')
      ) {
        const current =
          target.getAttribute('src') || parent.currentSrc || '';
        const swapped = this.swap(current);
        if (swapped && swapped !== current) {
          parent.setAttribute('data-file-fallback', 'true');
          parent.src = swapped;
          parent.load();
        }
      }
    }
  }

  private applyFallback(element: HTMLImageElement, attr: string): void {
    const current = element.src || element.getAttribute(attr) || '';
    const swapped = this.swap(current);
    if (swapped && swapped !== current) {
      element.setAttribute('data-file-fallback', 'true');
      element.setAttribute(attr, swapped);
    }
  }

  private swap(url: string): string {
    if (!url) {
      return '';
    }
    if (url.startsWith(this.primary)) {
      return url.replace(this.primary, this.backup);
    }
    if (url.startsWith(this.backup)) {
      return url.replace(this.backup, this.primary);
    }
    return '';
  }
}
